module.exports = __webpack_public_path__ + "img/fun-icon-4.fbef73f1.png";